import ApplicationModel, { attr } from '../ApplicationModel';
import { type DiscoveryScriptAttributes } from './generated/DiscoveryScriptAttributes';
import { model } from '../modelBuilder';

interface DiscoveryScript extends DiscoveryScriptAttributes {}

@model
class DiscoveryScript extends ApplicationModel {
  // Start auto-generated
  static typename: 'DiscoveryScript' = 'DiscoveryScript';
  get typename(): 'DiscoveryScript' {
    return 'DiscoveryScript';
  }

  static internalTypename: 'Discovery::Script' = 'Discovery::Script';
  get internalTypename(): 'Discovery::Script' {
    return 'Discovery::Script';
  }

  static filterType = 'ScriptFilters!';
  static filters = { id: '[ID!]', discoveryStudyId: '[ID!]' };

  static fields = {
    createdAt: attr({ readable: true }),
    discoveryScriptPromptsCount: attr({ readable: true }),
    discoveryStudyId: attr({ readable: true }),
    id: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    discoveryStudy: attr.belongsTo({
      readable: true,
      typename: 'DiscoveryStudy',
    }),
    discoveryScriptPrompts: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default DiscoveryScript;
